import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { SetPaymentRequestSummary } from '@app/finxone-web-frontend/app/lib/actions/notification.action';
import {
  GeneratePaymentRequest,
  GetPaymentRequest,
  ResetPaymentRequestPayload,
} from '@app/finxone-web-frontend/app/lib/actions/payment-request.action';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { ConfirmationService } from '@app/finxone-web-frontend/app/lib/services/confirmation-service/confirmation-service';
import {
  ApiActions,
  UpdateApiIsLoadingAction,
} from '@app/finxone-web-frontend/app/lib/state/api-loading.state';
import { PaymentRequestState } from '@app/finxone-web-frontend/app/lib/state/payment-request.state';
import { ProjectSettingsState } from '@app/finxone-web-frontend/app/lib/state/project-settings.state';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { getQueryParamValueByKey } from '@app/finxone-web-frontend/app/lib/utils/query-params.utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  Columns,
  ConfirmationClaimType,
  EntityType,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  ZoneActionOptions,
  baseCssConfigStyle,
  buttonNestedWidgetConfigStyles,
} from '@finxone-platform/shared/sys-config-types';
import { PaymentRequestListResponse, PaymentRequestPayload } from '@finxone-platform/shared/utils';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, catchError, map, takeUntil, tap } from 'rxjs';
import { BaseComponent } from '../base/base.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-payment-request-pending-approval-widget',
  templateUrl: './payment-request-pending-approval-widget.component.html',
})
export class PaymentRequestPendingApprovalWidgetComponent extends BaseComponent implements OnInit {
  actionOptions: ZoneActionOptions[] = [{ label: 'View Payment', value: 'view-payment', isIdNotExist: '' }];
  @Select(PaymentRequestState.paymentRequest)
  public paymentRequest!: Observable<any>;
  public paymentRequestData: PaymentRequestListResponse[] = [];
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public pageNumber = 1;
  public textStyle: baseCssConfigStyle;
  public columns: Columns[] = [];
  public totalListCount = 10;
  public tableHeaderColumns: any;
  public isClickMenuIcon = false;
  public menuPopupCss = {};
  private searchText = '';
  public actionButton = '';
  public confirmButtonStyle: baseCssConfigStyle = {};
  public actionDropdownStyle: baseCssConfigStyle = {};
  public showConfirmButton = false;
  public dropdownOptions = [
    { label: 'Select action ', value: '' },
    { label: 'Approve', value: 'approved' },
    { label: 'Reject', value: 'rejected' },
  ];
  public enableClickableRow = false;
  private approvedStatus: string;
  private selectedIds: string[];
  private statusAction: string;
  private smsAuthenticationEnabled: boolean;
  public selectedOption: { label: string; value: string };
  public dropdownAction = {
    isAllowDropdownAction: false,
    dropdownLabel: '',
    dropdownWidth: 25,
  };

  constructor(
    public store: Store,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private router: Router,
    private configService: ConfigService,
    private alertService: AlertHandlerService,
    private accountService: AccountService,
    private confirmationService: ConfirmationService,
  ) {
    super();
    this.getPageData();
  }

  ngOnInit() {
    this.selectedOption =
      this.dropdownOptions?.find((option) => option?.value === '') ?? this.dropdownOptions[0];
    this.enableClickableRow = true;
    this.actionButton =
      this.dataIn.widgetConfig?.nestedWidgets?.['actionConfirmButton']?.widgetProperties?.textContent ?? '';
    this.confirmButtonStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(this.dataIn, 'actionConfirmButton'),
      buttonNestedWidgetConfigStyles,
    );
    this.actionDropdownStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(this.dataIn, 'actionDropDown'),
      buttonNestedWidgetConfigStyles,
    );

    this.smsAuthenticationEnabled = this.store.selectSnapshot(
      ProjectSettingsState.getProjectSettings,
    )?.smsAuthenticationEnabled;

    const isWorkflow = this.configService.getActiveConfigType().isWorkflow;
    if (isWorkflow) {
      if (this.dataIn.attri?.['viewListOption'] === 'pending') {
        this.dropdownAction = this.dataIn.attri.widgetProperties?.['dropdownActionSetting'] ?? {
          ...this.dropdownAction,
          isAllowDropdownAction: true,
        };
        this.showConfirmButton = true;
      }
    } else {
      this.getRole();
    }
  }

  getRole() {
    const userProfile = this.store.selectSnapshot(ProfileState.getProfile);
    const activeOrg = userProfile?.orgList?.find((org) => org.id === userProfile.activeOrganisationId);
    if (
      activeOrg?.roles?.includes('payment-approver') &&
      this.dataIn.attri?.['viewListOption'] === 'pending'
    ) {
      this.dropdownAction = this.dataIn.attri.widgetProperties?.['dropdownActionSetting'] ?? {
        ...this.dropdownAction,
        isAllowDropdownAction: true,
      };
      this.showConfirmButton = true;
    }
  }

  public get pageSize(): number {
    if (this.dataIn.attri['pageSize'] != null) return Number(this.dataIn.attri['pageSize']);
    else return 10;
  }

  public get pagingEnabled(): boolean {
    if (this.dataIn.attri['pagingEnabled'] != null) return this.dataIn.attri['pagingEnabled'];
    else return true;
  }

  onPageChange(event: { first: number; page: number; pageCount: number; rows: number }) {
    this.pageNumber = event.first / event.rows + 1;
    this.dataIn.attri['pageSize'] = event.rows;
    this.dispatchPaymentRequest();
  }

  public getPageData() {
    this.statusAction = this.dataIn.attri?.['viewListOption'] ?? '';
    this.dispatchPaymentRequest();
    this.paymentRequest
      .pipe(
        takeUntil(this.destroy$),
        map((listData) => {
          this.paymentRequestData = [];
          this.totalListCount = listData?.paymentRequestPendingAndApproval?.totalItems;
          this.paymentRequestData = listData?.paymentRequestPendingAndApproval?.result;
        }),
      )
      .subscribe();
  }

  private dispatchPaymentRequest() {
    if (this.dataIn.attri?.widgetProperties?.['entityInformation']?.entity === EntityType.PaymentRequest) {
      this.store.dispatch(
        new GetPaymentRequest(this.pageNumber, this.pageSize, this.statusAction, this.searchText),
      );
    }
  }

  public searchValue(searchText: string) {
    this.searchText = searchText;
    this.pageNumber = 1;
    this.dispatchPaymentRequest();
  }

  public rowData(event: any) {
    if (event.paymentType === 'single') {
      this.accountService
        .getPaymentRequestDetailsById(event.typeId)
        .pipe(
          tap((response) => {
            this.store.dispatch(new SetPaymentRequestSummary(response));
          }),
          catchError<unknown, Observable<boolean>>((_err) => {
            throw _err;
          }),
        )
        .subscribe();
      if (this.dataIn.attri?.['viewListOption'] === 'pending') {
        this.router.navigateByUrl(
          `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/payment-summary-approvers-decision`,
        );
      }
      if (this.dataIn.attri?.['viewListOption'] === 'approved') {
        this.router.navigateByUrl(`/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/request-approved`);
      }
      if (this.dataIn.attri?.['viewListOption'] === 'rejected') {
        this.router.navigateByUrl(`/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/request-rejected`);
      }
    }

    if (event.paymentType === 'bulk') {
      this.store.dispatch(
        new UpdateFormDataActionWithId(
          {
            masterFileId: event.typeId,
          },
          FormActionTypeEnum.BULK_PAYMENTS,
        ),
      );
      this.router.navigateByUrl(
        `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/bulk-payment-summary-elaborated-view-approver-reject`,
      );
    }
  }

  public storeSelectedItemsIds(event: string[]) {
    this.selectedIds = event;
  }

  public processSelectedItemsAndStoreIds(event: PaymentRequestListResponse[]) {
    if (event?.length) {
      const itemIds = event.map((item: { id: string }) => item.id);
      this.selectedIds = itemIds;
    } else {
      this.selectedIds = [];
    }
  }

  public dropDownValueChange(event: string) {
    this.approvedStatus = event;
  }

  public onConfirm(event: any) {
    this.store.dispatch(new ResetPaymentRequestPayload());
    const payload: PaymentRequestPayload = {
      ids: this.selectedIds,
      approvedStatus: this.approvedStatus,
    };
    if (payload.approvedStatus && payload.ids?.length) {
      if (this.smsAuthenticationEnabled) {
        const loadingAction = ApiActions.approveRejectPaymentRequest;
        const subscription = this.confirmationService
          .checkConfirmation(undefined, loadingAction)
          .subscribe(() => {
            this.generatePaymentRequest(payload);
            subscription.unsubscribe();
          });
        this.confirmationService.confirmAction(
          ConfirmationClaimType.APPROVE_REJECT_PAYMENT,
          undefined,
          true,
          loadingAction,
        );
      } else {
        this.store.dispatch(new GeneratePaymentRequest(payload)).subscribe({
          next: () => {
            if (
              this.dataIn.attri?.widgetProperties?.['entityInformation']?.entity === EntityType.PaymentRequest
            ) {
              this.store.dispatch(
                new GetPaymentRequest(1, this.pageSize, this.statusAction, this.searchText),
              );
            }
            this.alertService.showAlertFn('success', `Payment ${this.approvedStatus} successfully.`);
          },
          error: (err) => {
            console.error('Error generating payment request:', err);
          },
        });
      }
    } else {
      this.alertService.showAlertFn(
        'error',
        'Please make sure to select an action type and payment before proceeding.',
      );
    }
  }

  private generatePaymentRequest(payload: PaymentRequestPayload) {
    payload.accessToken = getQueryParamValueByKey('confirmation');
    this.store.dispatch(new GeneratePaymentRequest(payload)).subscribe({
      next: () => {
        this.store.dispatch(new UpdateApiIsLoadingAction(ApiActions.approveRejectPaymentRequest, false));
        this.alertService.showAlertFn('success', `Payment ${payload.approvedStatus} successfully.`);
        this.router.navigateByUrl(
          `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/pending-and-approved-payment-requests`,
        );
      },
      error: (err: HttpErrorResponse) => {
        if (err.status !== 404) {
          this.store.dispatch(new UpdateApiIsLoadingAction(ApiActions.approveRejectPaymentRequest, false));
          this.router.navigateByUrl(
            `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/pending-and-approved-payment-requests`,
          );
        }
        console.error('Error generating payment request:', err);
      },
    });
  }
}
